// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ed-3";
export var flatBottomCorners = "_ed-5";
export var productImage = "_ed-0";
export var quantityContainer = "_ed-2";
export var quantityHeader = "_ed-6";
export var tooltip = "_ed-1";
export var wrapAndEllipsesOverflow = "_ed-4";